import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Row } from "antd";
import "./DeleteManagerModal.less";

type DeleteManagerModalProps = {
  onClose: () => void;
  onDelete: () => void;
};

const DeleteManagerModal: React.FC<DeleteManagerModalProps> = ({ onClose, onDelete }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-24">{t("delete-manager-title")}</Typography.Text>
        </div>
        <div className="bottom-modal-body mt-10">
          <div className="bottom-modal-description">{t("delete-manager-desc")}</div>
          <button className="bottom-modal-white-button mt-14" onClick={onDelete}>
            <Typography.Text className="bottom-modal-white-button-title">{t("Delete")}</Typography.Text>
          </button>

          <button className="bottom-modal-grey-button" onClick={onClose}>
            <Typography.Text className="bottom-modal-grey-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteManagerModal;
